export default __webpack_public_path__ + "static/delassus-acf432e4d9c6a84c2f0be47cff5dbe91.jpg";